import Sidebar from '@/components/mixins/sidebar'
import _ from 'lodash'
import { ApplicationsAPI } from '@/api'
import DialogSetting from '@/components/application/components/DialogSetting.vue'
import DialogApplicationAdd from '@/components/application/components/DialogApplicationAdd.vue'
import DialogApplicationEdit from '@/components/application/components/DialogApplicationEdit.vue'

export default {
  name: 'application-component',
  components: {DialogApplicationEdit, DialogApplicationAdd, DialogSetting, Sidebar},
  computed: {
    selectInput() {
      return _.find(this.selectOptions.list, {value: this.form.search_key})
    },
  },
  data() {
    return {
      currentPk: null,
      isSettingModalVisible: false,
      isAddModalVisible: false,
      isEditModalVisible: false,
      tableClass: "",
      form: {
        search_key: 'package_id',
        search_value: '',
      },
      selectOptions: {
        list: [
          {value: 'package_id', text: this.$t('package_id'), type: 'keyword'},
          // {value: 'file_name', text: this.$t('file_name'), type: 'keyword'},
          {value: 'app_name', text: this.$t('app_name'), type: 'keyword'},
          {value: 'app_version', text: this.$t('app_version'), type: 'keyword'},
          {value: 'url', text: this.$t('url'), type: 'keyword'},
        ],
      },
      tableData: {
        fields: [
          {key: 'detail', label: '', sortable: false, thStyle: {minWidth: '35px', width: '35px'}},
          {key: 'package_id', label: this.$t('package_id'), sortable: true, thStyle: {minWidth: '120px'}},
          // {key: 'file_name', label: this.$t('file_name'), sortable: true, thStyle: {minWidth: '120px'}},
          {key: 'app_name', label: this.$t('app_name'), sortable: true, thStyle: {minWidth: '120px'}},
          {key: 'app_version', label: this.$t('app_version'), sortable: true, thStyle: {minWidth: '120px'}},
          {key: 'url', label: this.$t('url'), sortable: true, thStyle: {minWidth: '150px'}},
          {key: 'action', label: this.$t('action'), sortable: false, thStyle: {minWidth: '50px'}},
        ],
        pagination: {
          by: 'create_time',
          limit: 24,
          offset: 0,
          order: 'desc',
          
          search_key: '',
          search_value: '',
          search_mode: 'pagination',
          
          total: 1,
          current: 1,
          perOptions: [
            {value: 12, text: '12'},
            {value: 24, text: '24'},
            {value: 36, text: '36'},
          ],
        },
      },
    }
  },
  methods: {
    fetchApplicationList(ctx) {
      if (ctx.sortBy === "") return
      
      this.tableData.pagination.by = ctx.sortBy
      this.tableData.pagination.limit = ctx.perPage
      this.tableData.pagination.order = ctx.sortDesc ? "desc" : "asc"
      this.tableData.pagination.offset = (this.tableData.pagination.current - 1) * this.tableData.pagination.limit
      
      let params = {
        by: this.tableData.pagination.by,
        limit: this.tableData.pagination.limit,
        offset: this.tableData.pagination.offset,
        order: this.tableData.pagination.order,
        
        search_key: this.tableData.pagination.search_key,
        search_value: this.tableData.pagination.search_value,
        search_mode: "pagination",
      }
      
      return ApplicationsAPI.get('', {params})
          .then(res => {
            const {objects, meta, status} = res.data
            
            if (status !== 200) {
              this.$awn.warning(this.$t('data_get_fail'))
              return []
            }
            
            this.tableData.list = objects
            this.tableData.pagination.total = meta.total_count
            
            return this.tableData.list
          })
    },
    changeSearchSelect() {
      if (this.selectInput.type === 'select') {
        this.form.value = this.selectInput.list[0].value
      } else {
        this.form.value = ''
      }
    },
    search() {
      this.tableData.pagination.current = 1
      this.tableData.pagination.search_key = this.form.search_key
      this.tableData.pagination.search_value = this.form.search_value
      this.form.search_value = ''
      this.$refs.applicationTableBody.refresh()
    },
    handleAdd() {
      this.isAddModalVisible = true
    },
    openSettingDialog(pk) {
      this.currentPk = pk
      this.isSettingModalVisible = true
    },
    openEditDialog(pk) {
      this.currentPk = pk
      this.isEditModalVisible = true
    },
    deleteApplication(pk) {
      let params = {
        title: "LinkMeMine",
        context: { path: "delete_checked_application_confirm" },
        withoutInput: true,
        submit: {
          size: "sm",
          color: "danger",
          text: { path: "delete" },
        },
      }
      this.AppState.$emit("show-confirm-dialog", params, (key, data) => {
        if (key !== "submit") return
        ApplicationsAPI.delete(`${pk}`)
            .then(res => {
              this.$awn.success(this.$t("app_info_delete"))
              this.$refs.applicationTableBody.refresh()
            })
      })
    },
    closeModal() {
      this.isSettingModalVisible = false
      this.isAddModalVisible = false
      this.isEditModalVisible = false
      this.currentPk = null
      this.$refs.applicationTableBody.refresh()
    },
    openDropDown() {
      this.tableClass = "show-dropdown"
    },
    closeDropDown() {
      this.tableClass = ""
    },
  }
}